"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTotalPlaysQuery = exports.btbApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var statsBaseQuery_1 = require("../../utils/statsBaseQuery");
exports.btbApi = (0, react_1.createApi)({
    reducerPath: "btbApi",
    baseQuery: (0, statsBaseQuery_1.statsBaseQuery)("btbApi", process.env.STATS_BTB_API),
    tagTypes: ["btb"],
    endpoints: function (builder) { return ({
        getTotalPlays: builder.query({
            query: function (_a) {
                var region = _a.region, campaignId = _a.campaignId;
                return ({ region: region, url: "/services-btbGetTotalPlays?campaignId=".concat(encodeURIComponent(campaignId)) });
            },
            transformResponse: function (response) { var _a; return (_a = response === null || response === void 0 ? void 0 : response.totalPlays) !== null && _a !== void 0 ? _a : 0; },
            providesTags: ["btb"],
        }),
    }); },
});
exports.useGetTotalPlaysQuery = exports.btbApi.useGetTotalPlaysQuery;
